import React from "react";
import PropTypes from "prop-types";
import { pure } from "recompose";
import List from "immutable";

function PriceWidgetPlaceholder({ propertyList }) {
  return <div id="widget123_placeholder" data-hotel={propertyList[0].get("ticker")} />;
}

//TODO: Correct proptypes
// PriceWidgetPlaceholder.propTypes = {
//   propertyList: PropTypes.instanceOf(List).isRequired
// };

export default pure(PriceWidgetPlaceholder);
